import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { GetFlexMarketSubscriptionsQuery } from "@/api/hasura/generated/graphql"
import { FlexMarketSubscriptionParser } from "@/models/flexMarketSubscription/flexMarketSubscription.parser"
import { IFlexMarketSubscription } from "@/models/flexMarketSubscription/flexMarketSubscription.types"

export interface IFlexMarketSubscriptionService {
  getForAccount(
    billingAccountId: number,
  ): QueryResult<IFlexMarketSubscription[]>
}

class FlexMarketSubscriptionServiceClass implements IFlexMarketSubscriptionService {
  getForAccount(billingAccountId: number) {
    return useQuery({
      ...HasuraQueries.flexMarketSubscription.getSubscriptionsForAccount(
        billingAccountId,
      ),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data: GetFlexMarketSubscriptionsQuery) => {
        return data.flex_market_subscription.map(
          FlexMarketSubscriptionParser.toDomain,
        )
      },
    })
  }
}

export const FlexMarketSubscriptionService =
  new FlexMarketSubscriptionServiceClass()
